import React from 'react';
import ReactDOM from 'react-dom/client';


//import "Styles/scss/mainstyle.scss";
import "Styles/scss/current/app.scss";
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
//import 'Styles/stylevariables.css';
import 'Styles/psoppcStyles.css';
//import 'Styles/stylesheets/index.css';

import {store, persistor} from './Store/index';
import { PersistGate } from 'redux-persist/integration/react'
import TagManager from 'react-gtm-module';
import { config } from 'Utils/config';
import {getIds} from 'Utils/GA4/GTM';

const d = getIds();

const tagManagerArgs = {
    gtmId: d[0]
    
};
TagManager.initialize(tagManagerArgs);





const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
    <Provider store={store} >
        <PersistGate persistor={persistor}>
            <BrowserRouter>
                
                    <App/>
                
            </BrowserRouter>
        </PersistGate>
    </Provider>
);
 
